var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"transition":"opacity 0.2s ease","word-break":"break-word"},style:(("opacity : " + (_vm.ready ? 1 : 0))),attrs:{"id":("text_" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }